import { useEffect, useState } from "react";

import { api } from "../../lib/api";
import { CustomRegime } from "../../types/customRegime";
import { List } from "../../types/resquest";
import { getToken } from "../../storage/auth";
import {DataTableUtils} from "../../components/DataTable/DataTableUtils";

interface IList {
  keyword?: string;
  page?: number;
  limit?: number;
  sort?: string;
}

const entity = "customsRegimes";
const dataTableUtils = new DataTableUtils(entity);

export const useList = (
  params?: IList,
  token?: string,
  isCombo?: boolean
): {
  data: CustomRegime[];
  meta: List;
  isLoading: boolean;
  combo: any[];
  error: Error;
} => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<CustomRegime[]>([{} as CustomRegime]);
  const [meta, setMeta] = useState<List>({} as List);

  const [error, setError] = useState<Error>({} as Error);
  const [combo, setCombo] = useState<any>();

  const render = () => {
    if (token) {
      if (isCombo === false || isCombo === undefined) {
        return "pagination";
      }
    }
  };

  useEffect(() => {
    if (render() === "pagination") {
      (async function () {
        setIsLoading(true);
        const response = await dataTableUtils.findPaginate(params);
        const {total, data, currentPage, totalPages, limit} = response.data;
        setData(data);
        setMeta((prevState) => ({
          ...prevState,
          total,
          totalPages,
          limit,
          currentPage,
        }));
        setIsLoading(false)
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, token, isCombo]);

  useEffect(() => {
    if (token && isCombo === true) {
      setIsLoading(true);
      api
        .get(`/${entity}/getCombo`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const { data } = response;
          setCombo(data);
        })
        .catch(setError)
        .finally(() => setIsLoading(false));
    }
  }, [isCombo, params, token]);

  return { data, meta, isLoading, combo, error };
};

export const update = async (
  id: number | string,
  currency?: CustomRegime
): Promise<CustomRegime> => {
  const { data } = await api.patch(`/${entity}/${id}`, currency);

  return data;
};

export const isInUse = async (id: number | string): Promise<any> => {
  const { data } = await api.get(`/${entity}/isInUse/${id}`);

  return data;
};

export const deleteCustomRegime = async (
  id: number | string
): Promise<CustomRegime> => {
  const { data } = await api.delete(`/${entity}/${id}`);

  return data;
};

export const create = async (currency: CustomRegime): Promise<CustomRegime> => {
  const { data } = await api.post(`/${entity}`, currency);

  return data;
};

export const createCopy = async (
  currency: CustomRegime[]
): Promise<CustomRegime[]> => {
  const { data } = await api.post(`/${entity}/copy`, currency);

  return data;
};

export const exportAll = async (params: any) => {
  let xlsxData = [
    { label: "Id", value: "ID_REGIME" },
    { label: "Description", value: "DESCRICAO_REGIME" },
    { label: "SAP Code", value: "CODIGO_SAP" },
    {
      label: "Status",
      value: (row: any) => (row.ATIVO ? "Active" : "Inactive"),
    },
  ]
  await dataTableUtils.exportAll({params, xlsxData, filename: "CustomsRegime"});
};

export const getCenters = async (center) => {
  if(!center?.id) return;
  const { data } =  await dataTableUtils.findPaginate({
    ID_CENTRO: center.id,
    ATIVO: true,
    page: 1
  });
  return data;
}

export const getCustomRegimeCombos = async (ID_CENTRO?: number) => {
  const { data } = await api.get("/customsRegimes/getCombo");

  return data;
}